import perksSettingsService from "@irati/deals/services/perksSettings";
import authentication from "@irati/auth";
export var benefitsSchemeSettings = function () {
    var perksSettings = perksSettingsService.getSync(authentication.userTenant().uuid);
    return perksSettings.companyBenefits || {};
};
